import { Button } from '@lifeomic/chroma-react/components/Button';
import React, { useCallback, useState } from 'react';
import { type KnowledgeBaseCitation } from '../../../../../util/knowledgeBaseCitation';
import {
  useOpenKnowledgeBaseFile,
  type OpenCsvKnowledgeBaseFile,
} from './useOpenKnowledgeBaseFile';
import { CsvAttachmentModal } from './CsvAttachmentViewer';

export type KnowledgeBaseCitationInlineProps = {
  citation: KnowledgeBaseCitation;
};

/**
 * Opens KB-backed files via file-service (aligned with qa-agent citation
 * handling). For CSV files we render an in-app modal table instead of letting
 * the browser download the file, since browsers can't natively render CSV.
 */
export const KnowledgeBaseCitationInline: React.FC<
  KnowledgeBaseCitationInlineProps
> = ({ citation }) => {
  const [csvFile, setCsvFile] = useState<OpenCsvKnowledgeBaseFile | null>(null);

  const onOpenCsv = useCallback((file: OpenCsvKnowledgeBaseFile) => {
    setCsvFile(file);
  }, []);

  const openKnowledgeBaseFile = useOpenKnowledgeBaseFile(citation, {
    onOpenCsv,
  });

  return (
    <>
      <Button
        variant="outlined"
        title={citation.title}
        onClick={() => void openKnowledgeBaseFile()}
      >
        {citation.displayName}
      </Button>
      {csvFile && (
        <CsvAttachmentModal
          isOpen={true}
          onDismiss={() => setCsvFile(null)}
          url={csvFile.url}
          downloadUrl={csvFile.downloadUrl}
          fileName={csvFile.fileName}
          data-testid="kb-citation-csv"
        />
      )}
    </>
  );
};
